import { AlertTriangle, CheckCircle2, Circle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import type { WizardStepStatus } from './step-status'

type WizardSidebarStepProps = {
  title: string
  stepLabel: string
  status: WizardStepStatus
  onClick: () => void
}

// Los cuatro estados de un paso, con los tokens del sistema. Llevaban
// `emerald-500` y `amber-500` escritos a mano: los mismos dos estados que en el
// resto de la aplicacion se dicen con `success` y `warning`, y que ahi si
// cambian con el tema.
const ESTADO = {
  current: { caja: 'border-primary/40 bg-primary/10', Icono: Circle, icono: 'fill-primary text-primary' },
  completed: { caja: 'border-success/30 bg-success/10', Icono: CheckCircle2, icono: 'text-success' },
  warning: { caja: 'border-warning/30 bg-warning/10', Icono: AlertTriangle, icono: 'text-warning' },
} as const

export function WizardSidebarStep({ title, stepLabel, status, onClick }: WizardSidebarStepProps) {
  const estado = ESTADO[status as keyof typeof ESTADO]
  const Icono = estado?.Icono ?? Circle

  return (
    // `size="tarjeta"` es el tamano de un boton que ES una ficha: su altura la
    // decide lo que lleva dentro. Antes esto era un `<button>` crudo con su
    // relleno escrito a mano.
    <Button
      variant="ghost"
      size="tarjeta"
      onClick={onClick}
      aria-current={status === 'current' ? 'step' : undefined}
      className={cn(
        'mb-1 flex-row items-center gap-2 border',
        estado ? estado.caja : 'border-border bg-background/30 hover:bg-muted/50',
      )}
    >
      <Icono className={cn('h-4 w-4 shrink-0', estado ? estado.icono : 'text-muted-foreground')} />
      <span className="min-w-0">
        <span className="block text-xs text-muted-foreground">{stepLabel}</span>
        <span className="block truncate text-sm font-medium">{title}</span>
      </span>
    </Button>
  )
}
